define('pages/login',['jquery', 'appquery', 'app', 'modules/setup'], function($, $$, App, Setup) {
    $$ = $$('login');

    return {
        init : function(data) {
            App.idleTimer.stop();
            var loginForm = $$('#loginForm');

            if(data && data.message) {
                loginForm.prepend('<div class="box m-b-sm p-sm alert alert-danger">' + data.message + '</div>');
            }

            loginForm.submit(function(e) {
                e.preventDefault();

                var loginForm = $(this);
                var formData = loginForm.serializeObject();

                $$('#invalid-login').remove();
                if(!formData.username.trim() || !formData.password) {
                    loginForm.find('.form-group:eq(0)').before('<div id="invalid-login" class="text-left"><label class="text-danger">Please enter a valid username and password </label></div>');
                    return;
                }
                var button = App.button(this).load().textContent('Logging in');
                App.api.call("/auth.login", formData, function (response) {
                    if(App.global('retailer_id') && App.global('retailer_id') != response.retailer.id) {
                        if(App.onRetailerChange()) {
                            return;
                        }
                    }

                    App.database.set({
                        'user' : {
                            name : response.name,
                            type : response.account_type
                        },
                        'retailer_id' : response.retailer.id,
                        'retailer_logo' : response.retailer.logo_url
                    }).then(function(){
                        if(data && data.onLogin) {
                            data.onLogin();
                        } else {
                            App.onLogin(response);
                        }
                    });
                }, function(message) {
                    button.reset().textContent('Login');
                    loginForm.find('.form-group:eq(0)').before('<div id="invalid-login" class="text-left"><label class="text-danger">'+ message +'</label></div>');
                });
            });
        },
        footer : function (data) {
             return !!data && !!data.showFooter;
        }
    };
});
